import React, { useEffect, useState } from 'react';
import { Table, Input, Button, Flex, Typography, Space } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';

function EditableTable({
    readOnly = false,
    showHeader = false,
    initialDataSource = [],
    initialColumns = [],
    onSave,
    onDirty
}) {
    const [dataSource, setDataSource] = useState(
        // adiciona uma chave interna para o registro:
        initialDataSource.map((row, index) => ({ key: index, ...row }))
    );
    const [isSaving, setIsSaving] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        if (onDirty) {
            onDirty(isDirty);
        }
    }, [isDirty]);

    /**
     * Manipula as alterações na célula.
     * 
     * @param {String} key 
     * @param {Number} index
     */
    const onInputChange = (key, index) => (event) => {
        const nextData = [...dataSource];

        nextData[index][key] = event.target.value;

        setDataSource(nextData);
        setIsDirty(true);
    };

    /**
     * Mapeia as colunas especificadas em
     * células editáveis.
     */
    const editableColumns = initialColumns.map(column => ({
        ...column,
        render: (text, record, index) => (
            <Input.TextArea
                autoSize
                variant="borderless"
                size="small"
                value={text}
                placeholder="Clique para editar"
                onChange={onInputChange(column.dataIndex, index)}
                disabled={isSaving || readOnly}
            />
        ),
    }));

    /**
     * Manipula a ação de adicionar uma nova linha.
     */
    async function handleRowAdd() {
        let baseColumns = [...initialColumns]

        // deriva uma nova linha a partir das colunas especificadas:
        const newRow = baseColumns.reduce((previousColumns, column) => ({
            ...previousColumns,
            [column.dataIndex]: ''
        }), { key: dataSource.length })

        setDataSource([...dataSource, newRow]);
        setIsDirty(true);
    };

    /**
     * Manipula a ação de salvar os dados da tabela.
     */
    async function handleSave() {
        setIsSaving(true);
        
        const succeeded = await onSave({
            dataSource,
            initialColumns
        })
        
        if (succeeded) {
            setIsDirty(false);
        }

        setIsSaving(false);
    }

    const customAttrs = !readOnly ? {
        footer: () => (
            <Flex justify="space-between">
                <Space>
                    <Button
                        size="small"
                        type="dashed"
                        onClick={handleRowAdd}
                        icon={<PlusCircleOutlined />}
                        disabled={isSaving}
                    >
                        adicionar linha
                    </Button>
                </Space>

                {isDirty && (
                    <Button
                        size="small"
                        type="primary"
                        onClick={handleSave}
                        loading={isSaving}
                    >
                        salvar
                    </Button>
                )}
            </Flex>
        ),
    } : {}

    return (
        <>
            <Table
                bordered
                size="small"
                showHeader={showHeader}
                pagination={false}
                dataSource={dataSource}
                columns={editableColumns}
                {...customAttrs}
            />

            {isDirty && (
                <Typography.Text type="danger">
                    <small>você ainda <b>não salvou</b> as alterações</small>
                </Typography.Text>
            )}
        </>
    );
};

export default EditableTable;
